<mat-progress-bar
  class="progress"
  mode="query"
  *ngIf="authFormLoading$ | async"
/>

<div
  class="authentication-wrapper"
  fxLayout="row wrap"
  fxLayoutAlign="space-between start"
>
  <mat-tab-group fxFlex="100" fxFlex.lt-md="100" animationDuration="0ms">
    <mat-tab class="tab" label="ورود به سایت">
      <auth-login
        (auth-event)="onAuthentication($event)"
        [inner-router]="_innerRouter$"
        (loadingStart)="startLoading()"
        (stopLoading)="stopLoading()"
        [otp]="otp"
      />
      <div class="google-title">
        <span>سایر روش‌های ورود</span>
      </div>
      <div fxFlex="100" id="gSignInWrapper" (click)="swithOtp()" matRipple class="customBtn-wrapper">
        <div
          id="customBtn"
          class="customGPlusSignIn"
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          <span class="buttonText" *ngIf="!otp">ورود از طریق کد یک‌بار مصرف</span>
          <span class="buttonText" *ngIf="otp">ورود با نام کاربری و رمز عبور</span>
          <span class="icon" fxLayout="column" fxLayoutAlign="center center">
            <mat-icon svgIcon="mobile2" class="blue"></mat-icon>
          </span>
        </div>
      </div>
      <br />
      <div
        fxFlex="100"
        id="gSignInWrapper"
        (click)="googleAuthProcess()"
        matRipple
      >
        <!-- <div
          id="customBtn"
          class="customGPlusSignIn"
          fxLayout="row"
          fxLayoutAlign="center center"
        >
          <span class="buttonText">ورود توسط گوگل Google</span>
          <span class="icon" fxLayout="column" fxLayoutAlign="center center">
            <img src="assets/image/google-logo.webp" alt="Google Logo" />
          </span>
        </div> -->
      </div>
    </mat-tab>
    <mat-tab class="tab" label="ثبت نام">
      <auth-register
        (auth-event)="onAuthentication($event)"
        [inner-router]="_innerRouter$"
        (loadingStart)="startLoading()"
        (stopLoading)="stopLoading()"
      />
    </mat-tab>
  </mat-tab-group>
</div>
